import { COLORS } from "@coeff/utils";
import { Checkbox as AntCheckbox, Popover } from "antd";
import React, { useContext, useState } from "react";
import styled from "styled-components";

import { DEPRECATED_Button } from "../../common/DEPRECATED_Button";
import { GearIconSmall, InfoFilled } from "../../common/Icons";
import { Tooltip } from "../../common/Tooltip";
import { PPressContextParams, PpressContext, PPressComponentProps } from "../context";

import { StyledButton } from "./Button";

const StyledCheckbox = styled(AntCheckbox)`
  .ant-checkbox {
    .ant-checkbox-inner {
      border-width: 2px;
    }

    &.ant-checkbox-checked {
      .ant-checkbox-inner {
        background-color: ${COLORS.coeblue4};
        border-color: ${COLORS.coeblue4};
        border-width: 0px;
      }

      &.ant-checkbox-disabled {
        .ant-checkbox-inner {
          border-color: ${COLORS.coeblue4}!important;

          &:after {
            border-color: ${COLORS.black4}!important;
          }
        }
      }
    }
  }
`;

const DropdownWrap = styled.div`
  width: 220px;
  display: flex;
  gap: 10px;
  flex-direction: column;

  .coeff__card {
    margin: 0px;
    background: ${COLORS.white};

    > div {
      padding: 0px;
    }
  }
`;

type AdvanceSettingPopoverProps = {
  showPreserveFormatting?: boolean;
  preserveFormattingTooltip?: string;
} & PPressComponentProps;

export const AdvanceSettingPopover = ({
  showPreserveFormatting,
  preserveFormattingTooltip,
}: AdvanceSettingPopoverProps) => {
  const formState = useContext(PpressContext) as PPressContextParams;

  const { ppress_params: ppressParams } = formState;

  const [preserveFormattingValue, setPreserveFormattingValue] = useState(
    ppressParams["preserve_formatting"] ?? false
  );

  const [openAdvanceSettingPopover, setOpenAdvanceSettingPopover] = useState(false);

  return (
    <Popover
      content={
        <DropdownWrap>
          {showPreserveFormatting && (
            <StyledCheckbox
              checked={preserveFormattingValue}
              onChange={() => setPreserveFormattingValue(!preserveFormattingValue)}
            >
              <Tooltip title={preserveFormattingTooltip}>
                Preserve formatting <InfoFilled />
              </Tooltip>
            </StyledCheckbox>
          )}

          <div style={{ textAlign: "right" }}>
            <DEPRECATED_Button
              type="primary"
              onClick={() => {
                setOpenAdvanceSettingPopover(false);
                formState.updatePPressParams({
                  ...ppressParams,
                  preserve_formatting: preserveFormattingValue,
                });
              }}
              data-testid="advance-popover-submit-button"
            >
              Done
            </DEPRECATED_Button>
          </div>
        </DropdownWrap>
      }
      trigger="click"
      placement="bottomLeft"
      overlayClassName="no-arrow"
      visible={openAdvanceSettingPopover}
      onVisibleChange={visible => {
        setOpenAdvanceSettingPopover(visible);
      }}
    >
      <StyledButton data-testid="advance-setting-popover-open-button" className="toolbar-btn">
        <GearIconSmall style={{ margin: 0 }} />
      </StyledButton>
    </Popover>
  );
};
